import { faFilm, faStar, faUser } from '@fortawesome/free-solid-svg-icons';
import { SearchMovieFilterInterface } from './entities/search-movie-filter.interface';

/**
 * !NOTE the idea is use the properties *lable* and *placeholder* to show the text in the UI
 * !NOTE but the localization is not working as expected. This text will be translated by now
 * !NOTE using the standar pipe aproach.
 */

export const userFilter: SearchMovieFilterInterface = {
  type: 'user',
  label: $localize`:@@search-movie-filter.user:User`,
  labelTranslationKey: 'search-movie-filter.user',
  icon: faUser,
  placeholder: $localize`:@@public.filters.user.placeholder:Enter a user name…`,
  placeholderTranslationKey: 'public.filters.user.placeholder'
};
export const starFilter: SearchMovieFilterInterface = {
  type: 'star',
  label: $localize`:@@search-movie-filter.star:Star`,
  labelTranslationKey: 'search-movie-filter.star',
  icon: faStar,
  placeholder: $localize`:@@public.filters.star.placeholder:Enter a star name…`,
  placeholderTranslationKey: 'public.filters.star.placeholder'
};
export const movieFilter: SearchMovieFilterInterface = {
  type: 'movie',
  label: $localize`:@@search-movie-filter.movie:Movie`,
  labelTranslationKey: 'search-movie-filter.movie',
  icon: faFilm,
  placeholder: $localize`:@@public.filters.movie.placeholder:Enter a film title…`,
  placeholderTranslationKey: 'public.filters.movie.placeholder'
};
